import * as yup from 'yup';
import { TryMyOllie } from '@web/components';
import { requiredImageFromCMSSchema } from '../schemas';
import { schema as testimonalSchema } from './testimonial';

export const component = TryMyOllie;

const mealPlanSchema = yup
  .object({
    title: yup.string().required(),
    img: requiredImageFromCMSSchema,
    benefit: yup.string(),
    description: yup.string(),
  })
  .transform(value => ({
    title: value.title,
    img: value.img,
    benefit: value.benefit,
    description: value.description,
  }));

export const schema = yup
  .object({
    headline: yup.string().required(),
    subheadline: yup.string(),
    typography: yup.string(),
    backgroundColor: yup.string(),
    mealPlanTypes: yup.array(mealPlanSchema),
    testimonials: yup.array(testimonalSchema),
    image: requiredImageFromCMSSchema,
    ctaVariant: yup.string(),
    ctaText: yup.string(),
    reviewsCopy: yup.string(),
    id: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    subheadline: value.subheadline,
    typography: value.typography || undefined,
    backgroundColor: value.backgroundColor || undefined,
    mealPlanTypes: value.mealPlanTypes,
    image: value.image,
    ctaVariant: value.ctaVariant || 'primary',
    ctaText: value.ctaText || 'Pick my plan',
    testimonials: value.testimonials,
    reviewsCopy: value.reviewsCopy,
    id: value.id || value.component,
  }));
